import React from 'react'
import { compose } from 'recompose'
import withSelectFetch from '../withSelectFetch'
import withSpinning from '../../HOC/withSpinning'
import withSort from '../../HOC/withSort'
import CustomSelect from '../../../elements/Select/CustomSelect'

const TypeSelect = compose(
  withSelectFetch({ dropdown: 'employee', name: 'type' }),
  withSpinning,
  withSort
)(CustomSelect)

export default TypeSelect
